import { Injectable, signal } from '@angular/core'

/**
 * Hält den globalen Zustand für die Serverfehler-Seite im Browser.
 *
 * Fängt der {@link Response503Interceptor} im Browser einen 5xx-Fehler der
 * gea-api ab, wird statt eines Toasts app-weit die {@link ServerErrorComponent}
 * eingeblendet. Bei einer Navigation wird der Zustand zurückgesetzt.
 */
@Injectable({ providedIn: 'root' })
export class ServerErrorService {
  readonly active = signal(false)

  show() {
    this.active.set(true)
  }

  reset() {
    this.active.set(false)
  }
}
